import React, { useState } from 'react';
import Button from 'components/UI/Button';
import { connect } from 'react-redux';
import Row from 'components/UI/Layout/Row';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import PropTypes from 'prop-types';
import EditableTextInput from 'components/UI/Input/EditableTextInput';
import FormComponent from 'components/UI/Input/FormComponent';
import { common as requestQuoteBundleRules } from 'services/validation/rules/requestQuoteBundle.rules';
import produce from 'immer';
import ErrorMessage from 'components/UI/ErrorMessage';
import Col from 'components/UI/Layout/Col';
import { storeRequestQuoteBundle } from 'store/dispatchers/requestQuotes.dispatchers';
import { buildForm } from './buildForm';

function RequestQuoteBundleForm({
    requestQuoteId, onCancel, onSuccess, saveRequestQuoteBundle,
})
{
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [bundleForm, setBundleForm] = useState(
        {
            ...buildForm(requestQuoteBundleRules),
            data: {
                requestQuoteId,
                name: '',
            },
        },
    );

    const updateDataForm = (name, value) =>
    {
        const form = produce(bundleForm, (draft) =>
        {
            draft.data[name] = value;
        });

        setBundleForm({ ...form });
    };

    const cancelForm = async () =>
    {
        if (onCancel)
        {
            onCancel();
        }
    };

    const handleForm = async () =>
    {
        setIsLoading(true);
        setErrorMessage('');
        saveRequestQuoteBundle({ ...bundleForm.data }).then((r) =>
        {
            onSuccess(r);
        }).catch((e) =>
        {
            setErrorMessage(e.message ?? e);
        }).finally(() =>
        {
            setIsLoading(false);
        });
    };

    return (
        <FormComponent
            className="tw-gap-2"
            source={bundleForm}
            onFormChange={
                () =>
                {}
            }
        >
            <ErrorMessage errorMessage={errorMessage} />
            <Row className="tw-py-2">
                <h2 className="tw-text-xl tw-font-bold dark:tw-text-neutral-300">Create Package</h2>
            </Row>
            <Col className="tw-py-1 tw-gap-1">
                <EditableTextInput
                    containerClassName="tw-py-2 tw-w-full"
                    labelText="Name"
                    text={bundleForm.data.name}
                    editing
                    inputProps={{
                        path: 'name',
                        disabled: isLoading,
                        error: bundleForm.errorsBag.errors.name,
                        value: bundleForm.data.name,
                        placeholder: 'Package Name',
                        onChange: (value) => updateDataForm('name', value),
                    }}
                />
            </Col>

            <div className="tw-ml-8 tw-text-right">
                <Button onClick={cancelForm} customBg="tw-bg-white tw-text-black" type="custom" disabled={isLoading}>Cancel</Button>
                <Button onClick={handleForm} type="primary" margin="tw-ml-2" disabled={isLoading} loading={isLoading}>Save</Button>
            </div>

        </FormComponent>
    );
}

RequestQuoteBundleForm.propTypes = {
    requestQuoteId: PropTypes.number,
    saveRequestQuoteBundle: PropTypes.func,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
    });
};

const mapDispatchToProps = (dispatch) => ({
    saveRequestQuoteBundle(data)
    {
        return dispatch(storeRequestQuoteBundle(data));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestQuoteBundleForm);
